export default `
<section class="container second center">
<div class="mt-3">
    <img src="++{{section14Image}}">
</div>
</section>
`